import { BaseUser } from "./base-user.model";

export class UnknownUser extends BaseUser {

    public static toUnknownUser(obj: string | Object): UnknownUser {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of UnknownUser.
        return Object.assign(new UnknownUser(), obj2);
    }
}
